// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-03ed6ef6] .el-tabs {\n  height: 100%;\n}\n[data-v-03ed6ef6] .el-tabs .el-tabs__content {\n  height: calc(100% - var(--el-tabs-header-height) - 0.26667rem);\n}\n[data-v-03ed6ef6] .el-tabs .el-tabs__content .el-tab-pane {\n  height: 100%;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
